var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatePickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 25",
    x: 1,
    y: 3.66663,
    width: 16,
    height: 13.3333,
    rx: 2,
    stroke: "#7A7A7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 26",
    d: "M1 7.22218C1 5.76475 1 5.03603 1.3617 4.51947C1.49551 4.32836 1.66174 4.16214 1.85285 4.02832C2.3694 3.66663 3.09812 3.66663 4.55556 3.66663H13.4444C14.9019 3.66663 15.6306 3.66663 16.1472 4.02832C16.3383 4.16214 16.5045 4.32836 16.6383 4.51947C17 5.03603 17 5.76475 17 7.22218H1Z",
    fill: "#7A7A7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1",
    d: "M4.55566 1L4.55566 3.66667",
    stroke: "#7A7A7B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M13.4443 1L13.4443 3.66667",
    stroke: "#7A7A7B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 27",
    x: 4.55566,
    y: 9,
    width: 3.55556,
    height: 1.77778,
    rx: 0.5,
    fill: "#7A7A7B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 29",
    x: 4.55566,
    y: 12.5553,
    width: 3.55556,
    height: 1.77778,
    rx: 0.5,
    fill: "#7A7A7B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 28",
    x: 9.88904,
    y: 9,
    width: 3.55556,
    height: 1.77778,
    rx: 0.5,
    fill: "#7A7A7B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 30",
    x: 9.88904,
    y: 12.5553,
    width: 3.55556,
    height: 1.77778,
    rx: 0.5,
    fill: "#7A7A7B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerIcon);
export default __webpack_public_path__ + "static/media/date-picker-icon.ddc40a97d00ea0c050090efd029c1dad.svg";
export { ForwardRef as ReactComponent };